(function faq () {
    const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
    const compName = "faq";
    const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
    const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
        return;
    }

    const {auth, getPopular, isTracking, sendTrackingEvents} = GlobalSite.checkDependency('GlobalSite.inbentaApi');

    $(async () => {
        const faqList = document.querySelector('#faq-list');
        const errorBanner = faqList.querySelector('.faq__list-item--banner-message');
        const skeletonItems = faqList.querySelectorAll('.faq__list-item--loader');

        const [inbentaAuth, popularAnswers] = await Promise.all([
            auth(),
            getPopular('faq-home')
        ]).catch(reason => {
            Log.log(reason)
            return;
        })

        if (skeletonItems && skeletonItems.length > 0) {
            skeletonItems.forEach(item => item.remove());
        }

        if (faqList && popularAnswers && popularAnswers?.results?.length > 0 && inbentaAuth) {

            popularAnswers.results.forEach( answer => {
                const htmlAnswer = `
                    <li class="faq__list-item">
                        <details
                            data-tracking-type="click"
                            data-source="faq-home-track"
                            data-tracking-value="${answer.tracking.clickCode}"
                            class="accordion"
                        >
                            <summary class="accordion__title" aria-label="${answer.title}">
                                <h3>${answer.title}</h3>
                                <span class="accordion__title--icon i-chevron-down" />
                            </summary>
                            <div class="accordion__text">
                                ${answer.attributes.ANSWER_TEXT}
                            </div>
                        </details>
                    </li>
                `

                faqList.insertAdjacentHTML('afterbegin', htmlAnswer);
            });

            const faqAccordionList = document.querySelectorAll('#faq-list .faq__list-item .accordion');
            const inbentaTracking = await isTracking();

            if (faqAccordionList && faqAccordionList.length > 0 && inbentaTracking) {
                faqAccordionList.forEach(accordion => {
                    accordion.addEventListener('click', () => {
                        if (!accordion.hasAttribute('open')) {
                            const source = accordion.dataset.source;
                            const trackingType = accordion.dataset.trackingType;
                            const trackingValue = accordion.dataset.trackingValue;

                            sendTrackingEvents({ type: trackingType, data: { code: trackingValue }}, source);
                            Log.log({ trackingType, trackingValue, source });
                        }
                    });
                })
            }
        } else {
            errorBanner.classList.toggle('hide');
        }
    });
 })()